import { SOGetOrganization } from '../organization/so-get-organization';
import { SOGetPrice } from '../price/so-get-price';
import {ENSubscriptionStatus} from '../../enums';


export class SOPostSubscription {

  constructor(
    public organization: SOGetOrganization,
    public price: SOGetPrice,
    public status: ENSubscriptionStatus,
    public exRef: string = null,
  ) {
  }
  static construct(params: {[key: string]: any}) {
    return new SOPostSubscription(
      'exRef' in params ? params.exRef : null,
      'organization' in params ? params.organization : null,
      'price' in params ? params.price : null,
      'status' in params ? params.status : null,
    );
  }
}
